import { StylesConfig } from "react-select";

export const selectStyles: StylesConfig = {
  control: (styles) => ({ ...styles, height: "100%" }),
  placeholder: (styles) => ({
    ...styles,
    color: "#11204d",
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#11204d",
  }),
  option: (styles, { isSelected }) => {
    return {
      ...styles,
      color: isSelected ? "#11204d" : "#11204d",
    };
  },
  indicatorsContainer: (styles) => ({
    ...styles,
    color: "#11204d",
  }),
};

export const filterSelectStyles: StylesConfig = {
  control: (base, state) => ({
    ...base,
    minHeight: "48px",
    borderRadius: "0.75rem",
    borderWidth: "2px",
    borderColor: state.isFocused ? "#113F67" : "#e5e7eb",
    boxShadow: state.isFocused
      ? "0 0 0 2px #fff, 0 0 0 4px #113F67"
      : "none",
    paddingLeft: "1.75rem",
    "&:hover": {
      borderColor: state.isFocused ? "#113F67" : "#e5e7eb",
    },
  }),
  placeholder: (base) => ({
    ...base,
    color: "#9ca3af",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#11204d",
  }),
  option: (base, { isSelected }) => ({
    ...base,
    color: "#11204d",
    backgroundColor: isSelected ? "#e5e7eb" : base.backgroundColor,
  }),
  indicatorsContainer: (base) => ({
    ...base,
    color: "#11204d",
  }),
};

export const modalSelectStyles: StylesConfig = {
  control: (base, state) => ({
    ...base,
    minHeight: "44px",
    borderRadius: "0.5rem",
    borderWidth: "1px",
    borderColor: state.isFocused ? "#113F67" : "#e5e7eb",
    boxShadow: state.isFocused
      ? "0 0 0 2px #fff, 0 0 0 3px #113F67"
      : "none",
    "&:hover": {
      borderColor: state.isFocused ? "#113F67" : "#d1d5db",
    },
  }),
  placeholder: (base) => ({
    ...base,
    color: "#9ca3af",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#374151",
  }),
  option: (base, { isSelected, isFocused }) => ({
    ...base,
    backgroundColor: isSelected ? "#113F67" : isFocused ? "#f3f4f6" : "white",
    color: isSelected ? "white" : "#374151",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    color: "#6b7280",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 60,
  }),
};

export const toastStyles = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};
